var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"action-button"},[_c('button',{staticClass:"btn btn-sm btn-clean btn-icon btn-icon-md button-action",attrs:{"title":"Hapus"},on:{"click":function($event){$event.preventDefault();return _vm.deleteMethod.apply(null, arguments)}}},[_c('TrashIcon')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }